import { NodeModel } from "../_model/NodeModel";
import { DecorationSulphitationTower } from "./decorationSulphitationTower"
import { Types } from "../../utils/nodeTypes"
import Properties from "../_model/ModelEngineeringProperties";


class SulphitationTower extends NodeModel {
  constructor() {
    super("SulphitationTower");
    
    this.type = new Types().SulphitationTower;
    this.x = 0;
    this.y = 0;
    this.height = 150;
    this.width = 50;
    this.xImg = () => this.x + 2;
    this.yImg = () => this.y + 2;    
    this.srcImg = require("@/assets/Fluxogramas/torre_sulfitacao.png");
    this.data = [new Properties({...this })];
    
    this.decorate = async function(callback) {
      this.decorator = new DecorationSulphitationTower();
      await this.decorator.init(this,callback)
    };

    /* Métodos para serem implementados */ 

    this.clone = () => {
      let cloned = new SulphitationTower()
      cloned.id = this.id;
      cloned.idName = this.idName;
      cloned.type = this.type
      cloned.x = this.x
      cloned.y = this.y
      cloned.height = this.height
      cloned.width = this.width
      cloned.decorator = null
      cloned.data = this.data.map(d => d.clone())
      cloned.readOnly = this.readOnly;
			cloned.expressionVisible = this.expressionVisible;
      return cloned
    }

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.data = node.data.map(d => new Properties({...d }));
    }

  }
}

export { SulphitationTower };
